export class AppConsts {
  static apiUrl: string;
  static pageSize: number;
  static appBaseUrl: string;
  static appBaseHref: string; // returns angular's base-href parameter value if used during the publish

  
}
